<div
  *ngIf="isHome"
  class="m-3 my-4 flex gap-3 align-items-center text-primary font-semibold"
>
  <i class="pi pi-home text-2xl text-gray-500"></i>
  <span [style.font-size]="'1.3rem'"> Αρχική </span>
</div>

<p-breadcrumb [home]="defaultItem" [model]="items" *ngIf="!isHome">
  <ng-template pTemplate="item" let-item>
    <ng-container *ngIf="item.route; else elseBlock">
      <a
        [routerLink]="item.route"
        class="p-menuitem-link"
        [attr.aria-label]="item.label"
        (click)="onBreadcrumbClick(item)"
      >
        <i
          [ngClass]="[item.icon ? item.icon : '', 'text-color']"
          class="text-2xl"
          [attr.aria-hidden]="true"
        ></i>
        <span class="text-primary font-semibold">{{ item.label }}</span>
      </a>
    </ng-container>
    <ng-template #elseBlock>
      <a [href]="item.url" [attr.aria-label]="item.label" (click)="onBreadcrumbClick(item)">
        <span class="text-color">{{ item.label }}</span>
      </a>
    </ng-template>
  </ng-template>
</p-breadcrumb>
